export default "__VITE_ASSET__w01XgXfp__"